import {
  ATTRIBUTE_LIST_SUCCESS,
  ATTRIBUTE_LIST_FAIL,
  EDIT_ATTRIBUTES_SUCCESS,
  EDIT_ATTRIBUTES_FAIL,
  FETCH_START,
  FETCH_END,
  ATTRIBUTE_NAME_SUCCESS,
  DROPDOWN_START,
  DROPDOWN_END,
  DROPDOWN_DATA_SUCCESS,
  DROPDOWN_DATA_VALIDATION_SUCCESS,
  DROPDOWN_MASTER_DATA_SUCCESS,
  CREATE_ATTRIBUTE_HIERARCHY_SUCCESS,
  ATTRIBUTE_LIST_SINGLE_DATA_SUCCESS,
  ENROLLMENT_REQUEST_SETUP_SUCCESS,
  GET_ALL_ENROLLMENT_REQUEST_SETUP_SUCCESS,
  GET_ENROLLMENT_REQUEST_SETUP_BY_ID_SUCCESS,
  GET_ENROLLMENT_REQUEST_SETUP_BY_PROFILE_NAME_SUCCESS,
  ATTRIBUTE_MANAGEMENT_LIST_DATA_SUCCESS,
  DELETE_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS,
  DELETE_ENROLLMENT_MAPPING_PROFILE_SUCCESS,
  SAVE_EDIT_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS,
  UPDATE_ENROLLMENT_REQUEST_SETUP_SUCCESS,
  UPLOAD_ATTRIBUTE_MANAGEMENT_FILE_SUCCESS,
  CREATE_USER_DEFINED_ATTRIBUTE_SUCCESS,
  CREATE_USER_DEFINED_ATTRIBUTE_FAIL,
  UPDATE_USER_DEFINED_ATTRIBUTE_SUCCESS,
  UPDATE_USER_DEFINED_ATTRIBUTE_FAIL,
  GET_ATTRIBUTE_VALUES_SUCCESS,
  GET_ATTRIBUTE_TYPE_BY_ID_SUCCESS,
  CLEAR_ATTRIBUTE_TYPE_BY_ID,
  UPDATE_ATTRIBUTE_VALUE_SUCCESS,
  GET_DATA_TYPES,
  UPDATE_ATTRIBUTE_VALUE_FAIL,
  GET_ATTRIBUTE_DROPDOWN_VALUES,
  GET_ATTRIBUTE_DROPDOWN_VALUES_HANDSONTABLE,
  GET_ATTRIBUTE_LABELS_SUCCESS,
  PROCESS_ENROLLMENT_UPDATE_REQUEST_SUCCESS,
  PROCESS_ENROLLMENT_UPDATE_REQUEST_FAIL,
  POST_ENROLLMENT_UPDATE_REQUEST_SUCCESS,
  POST_ENROLLMENT_UPDATE_REQUEST_FAIL,
  GET_ENROLLMENT_UPDATE_REQUEST_SUCCESS,
  GET_ENROLLMENT_UPDATE_REQUEST_FAIL,
  GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_SUCCESS,
  GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_FAIL,
  GET_ENROLLMENT_UPDATE_REQUEST_LIST_SUCCESS,
  GET_ENROLLMENT_UPDATE_REQUEST_LIST_FAIL,
  GET_GPO_EXECUTION_LIST_SUCCESS,
  GET_GPO_EXECUTION_LIST_FAIL,
  GET_GPO_EXECUTION_BY_ID_SUCCESS,
  GET_GPO_EXECUTION_BY_ID_FAIL,
  CLEAR_GPO_EXECUTION_EDIT_CACHE,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { toast as appToast } from '../../../components/ToastManager';
import { ServerError } from '../../../library/constants';
import { history } from '../../../components/Helpers';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};

export const saveEditAttributeData = (data) => {
  return {
    type: EDIT_ATTRIBUTES_SUCCESS,
    data,
  };
};

export const getAttributeListDataSuccess = (data) => {
  return {
    type: ATTRIBUTE_LIST_SUCCESS,
    data,
  };
};

export const getAttributeListDataFailed = (error) => {
  return {
    type: ATTRIBUTE_LIST_FAIL,
    error,
  };
};
export const getAttributeNameDataSuccess = (data) => {
  return {
    type: ATTRIBUTE_NAME_SUCCESS,
    data,
  };
};
export const getDropdownValidationSuccess = (data) => {
  return {
    type: DROPDOWN_DATA_VALIDATION_SUCCESS,
    data,
  };
};
export const getDropdownDataSuccess = (data) => {
  return {
    type: DROPDOWN_DATA_SUCCESS,
    data,
  };
};
export const getDropdownDataMasterDataSuccess = (data) => {
  return {
    type: DROPDOWN_MASTER_DATA_SUCCESS,
    data,
  };
};
export const fetchDropdownStart = () => {
  return {
    type: DROPDOWN_START,
  };
};

export const fetchDropdownEnd = () => {
  return {
    type: DROPDOWN_END,
  };
};

export const getAttributeListData = (data, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAttributeListDataApi(data, page)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getAttributeListDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getAttributeListDataFailed(error));
        //appToast.showError(ServerError);
      });
  };
};

const getAttributeListDataApi = (data, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (page === 'hierarchy') {
    result = axios.get('eligibility-attrib-multiple', { headers: headers });
    return result;
  } else {
    result = axios.get('eligibility-attrib', { headers: headers });
    return result;
  }
};

export const createAttributeData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createAttributeDataApi({
      attribute_name: data.attribute_name,
      attribute_value: data.attribute_value,
      attribute_desc: data.attribute_desc,
      is_standard: false, // Always set to false for user-defined attributes
    })
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 200) {
          history.push('/attributes');
        } else {
          //appToast.showError(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //appToast.showError(ServerError);
      });
  };
};

const createAttributeDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('eligibility-attrib', data, { headers: headers });
  return result;
};

export const updateAttributeData = (attributeId, data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    let endpoint = '';

    if (type === 'edit') {
      endpoint = `/eligibility-attrib/${attributeId}`;
    } else {
      endpoint = data.attribute_type === 'standard'
        ? `/mdm/attribute-type/${attributeId}`
        : `/mdm/attribute-type/${attributeId}`;
    }

    return axios.put(endpoint, data, type)
      .then(response => {
        dispatch({
          type: data.attribute_type === 'standard'
            ? EDIT_ATTRIBUTES_SUCCESS
            : UPDATE_USER_DEFINED_ATTRIBUTE_SUCCESS,
          payload: response.data
        });
        if (type === 'edit' && response.status === 200) {
          history.push('/attributes');
        }
        dispatch(fetchEnd());
        return response.data;
      })
      .catch(error => {
        dispatch(fetchEnd());
        // appToast.showError(ServerError);
        // throw error;
      });
  };
};

const updateAttributeDataApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('eligibility-hierarchy-attrib/' + id, data, {
    headers: headers,
  });
  return result;
};

export const deleteAttributeData = (id, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteAttributeDataApi(id, page)
      .then((response) => {
        dispatch(fetchEnd());
        if (page === 'hierarchy') {
          dispatch(getAttributeListData(null, 'hierarchy'));
          appToast.showSuccess('Successfully deleted');
        } else {
          dispatch(getAttributeListData());
          appToast.showSuccess('Successfully deleted');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //appToast.showError(ServerError);
      });
  };
};

const deleteAttributeDataApi = (id, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (page === 'hierarchy') {
    result = axios.delete('eligibility-hierarchy-attrib/' + id, {
      headers: headers,
    });
    return result;
  } else {
    result = axios.delete('eligibility-attrib/' + id, { headers: headers });
    return result;
  }
};

// //upload File
export const uploadAttributeFile = (file, page) => {
  return (dispatch) => {
    uploadAttributeFileApi(file, page)
      .then((response) => {
        if (response.status === 200) {
          // window.location.reload();
          if (page === 'hierarchy') {
            dispatch(getAttributeListData(null, 'hierarchy'));
            appToast.showSuccess('File has been successfully uploaded.');
          } else {
            dispatch(getAttributeListData());
            appToast.showSuccess('File has been successfully uploaded.');
          }
        } else {
          appToast.showError(ServerError);
        }
      })
      .catch((error) => {
        // console.log(error.response.data.errors);
        const errorMessages = Object.values(error.response.data.errors);
        errorMessages.forEach((errorMessage) => {
          appToast.showError(errorMessage.trim());
        });
        // const errorMessages = error.response.data.errors.split(';');
        // errorMessages.forEach((errorMessage) => {
        //   appToast.showError(errorMessage.trim());
        // });
      });
  };
};

const uploadAttributeFileApi = (file, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  if (page === 'hierarchy') {
    result = axios.post('upload-hierarchy-attrib', file, { headers: headers });
    return result;
  } else {
    result = axios.post('eligibility-attrib-upload', file, {
      headers: headers,
    });
    return result;
  }
};

export const getAttributeNameList = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAttributeNameApi()
      .then((response) => {
        dispatch(getAttributeNameDataSuccess(response.data.response));
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getAttributeNameApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('/attribute-names', { headers: headers });
  return result;
};

export const uploadEDIFile = (file) => {
  return (dispatch) => {
    uploadEDIFileAPI(file)
      .then((response) => {
        if (response.status === 200) {
          // window.location.reload();
          appToast.showSuccess('File has been successfully uploaded.');
        } else {
          //appToast.showError(ServerError);
        }
      })
      .catch((error) => {
        //appToast.showError(ServerError);
      });
  };
};

const uploadEDIFileAPI = (file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('incoming-claim-edi', file, { headers: headers });
  return result;
};
//searched dropdown
export const getDropdownList = (table, data, type, version) => {
  return (dispatch) => {
    dispatch(fetchDropdownStart());
    getDropdownApi(table, data)
      .then((response) => {
        if (type === 'Master Data') {
          if (version == 'latest') {
            var listData = {
              records: { [data.key]: response.data.response.records },
              count: { [data.key]: response.data.response.records?.length }
            }
            dispatch(getDropdownDataMasterDataSuccess(listData));
          }
          else
            dispatch(getDropdownDataMasterDataSuccess(response.data.response));
        } else {
          dispatch(getDropdownDataSuccess(response.data.response));
        }
        dispatch(fetchDropdownEnd());
      })
      .catch((error) => {
        dispatch(fetchDropdownEnd());
      });
  };
};

const getDropdownApi = (table, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (table == null) {
    result = axios.post('dropdown-search', data, { headers: headers });
  } else {
    result = axios.post('dropdown-search/' + table, data, { headers: headers });
  }
  return result;
};

// Search DropDown Validation

export const getDropdownValidation = (table, data) => {
  return (dispatch) => {
    // dispatch(fetchDropdownStart());
    getDropdownValidationApi(table, data)
      .then((response) => {
        sessionStorage.setItem(
          'dropdownvalidation',
          JSON.stringify(response.data.response),
        );
        dispatch(getDropdownValidationSuccess(response.data.response));
        // dispatch(fetchDropdownEnd());
      })
      .catch((error) => {
        // dispatch(fetchDropdownEnd());
      });
  };
};

const getDropdownValidationApi = (table, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('dropdown-multi-search/' + table, data, {
    headers: headers,
  });
  return result;
};

//Attributes Hierarchy

// Add Attributes Hierarchy

export const createAttributeHierarchyData = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createAttributeHierarchyDataAPi(data, id)
      .then((response) => {
        dispatch(fetchEnd());
        const apiResponse = response?.data?.response;

        if (apiResponse == null || apiResponse.length === 0) {
          appToast.showError(ServerError);
          return;
        }

        dispatch(createAttributeHierarchyDataSuccess(apiResponse));
        appToast.showSuccess(response?.data?.message || 'Successfully saved');
        history.push('/attributes-management');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createAttributeHierarchyDataAPi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (id) {
    var result = axios.put('eligibility-hierarchy-attrib/' + id, data, {
      headers: headers,
    });
    return result;
  } else {
    var result = axios.post('eligibility-attrib-multiple', data, {
      headers: headers,
    });
    return result;
  }
};
export const createAttributeHierarchyDataSuccess = (data) => {
  return {
    type: CREATE_ATTRIBUTE_HIERARCHY_SUCCESS,
    data,
  };
};

// Get Single Attributes Hierarchy

export const getAttributeListSingleData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAttributeListSingleDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getAttributeListSingleDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getAttributeListSingleDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('eligibility-attrib-multiple/' + id, { headers: headers });
  return result;
};

export const getAttributeListSingleDataSuccess = (data) => {
  return {
    type: ATTRIBUTE_LIST_SINGLE_DATA_SUCCESS,
    data,
  };
};
export const createEnrollmentRequestSetup = (data, navigationState) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return createEnrollmentRequestSetupApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          createEnrollmentRequestSetupSuccess(response.data.response)
        );
        history.push({
          pathname: '/enrollment-roster-configuration-page',
          state: navigationState,
        });
        const message =
          response.data?.message ??
          response.data?.response?.message ??
          `${data.profile_name} created successfully`;
        appToast.showSuccess(message);
        return { success: true };
      })
      .catch((error) => {
        dispatch(fetchEnd());
        return Promise.resolve({ success: false, error });
      });
  };
};
const createEnrollmentRequestSetupApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('/config/enrollment-type', data, { headers });
};
export const createEnrollmentRequestSetupSuccess = (data) => {
  return {
    type: ENROLLMENT_REQUEST_SETUP_SUCCESS,
    data,
  };
};
export const getAllEnrollmentRequestSetup = (page = 1, limit = 0) => {
  return (dispatch) => {
    dispatch(fetchStart());

    getAllEnrollmentRequestSetupApi(page, limit)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getAllEnrollmentRequestSetupSuccess(response.data.response)
        );
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};

const getAllEnrollmentRequestSetupApi = (page, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get(
    `/config/enrollment-type`,
    { headers }
  );
};

export const getAllEnrollmentRequestSetupSuccess = (data) => {
  return {
    type: GET_ALL_ENROLLMENT_REQUEST_SETUP_SUCCESS,
    data,
  };
};
export const getEnrollmentRequestSetupById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());

    getEnrollmentRequestSetupByIdApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getEnrollmentRequestSetupByIdSuccess(response.data.response)
        );
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};
const getEnrollmentRequestSetupByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get(`/config/enrollment-type/${id}`, { headers });
};
export const getEnrollmentRequestSetupByIdSuccess = (data) => {
  return {
    type: GET_ENROLLMENT_REQUEST_SETUP_BY_ID_SUCCESS,
    data,
  };
};

export const clearGpoExecutionEditCache = () => ({
  type: CLEAR_GPO_EXECUTION_EDIT_CACHE,
});

export const getEnrollmentTypeDetails = (enrollmentType, onSuccess) => {
  return (dispatch) => {
    dispatch(fetchStart());

    return getEnrollmentTypeDetailsApi(enrollmentType)
      .then(async (response) => {
        dispatch(fetchEnd());
        const data = response?.data;
        const inner = data?.response ?? data;
        const records = inner?.records;
        const record = Array.isArray(records) && records.length > 0
          ? records[0]
          : (inner && typeof inner === 'object' && !Array.isArray(inner) ? inner : null);
        dispatch(getEnrollmentTypeDetailsSuccess(record));
        if (record && typeof onSuccess === 'function') {
          onSuccess(record);
        }

        const logNumber = data?.log_number ?? inner?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        dispatch(fetchEnd());

        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      });
  };
};

export const getEnrollmentTypeDetailsSuccess = (data) => {
  return {
    type: GET_ENROLLMENT_REQUEST_SETUP_BY_PROFILE_NAME_SUCCESS,
    data,
  };
};

const getEnrollmentTypeDetailsApi = (enrollmentType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  const encoded = encodeURIComponent(enrollmentType || '');
  return axios.get(`/config/enrollment-type?enrollment_type=${encoded}`, { headers });
};

export const deleteEnrollmentMappingProfile = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteEnrollmentMappingProfileApi(data.id)
      .then(() => {
        dispatch(fetchEnd());
        dispatch(deleteEnrollmentMappingProfileSuccess(data.id));
        appToast.showSuccess(`${data.profile_name} deleted successfully`);
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};

const deleteEnrollmentMappingProfileApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.delete(`/config/enrollment-type/${id}`, { headers });
};

export const deleteEnrollmentMappingProfileSuccess = (id) => {
  return {
    type: DELETE_ENROLLMENT_MAPPING_PROFILE_SUCCESS,
    id,
  };
};

export const updateEnrollmentRequestSetup = (id, data, navigationState) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return updateEnrollmentRequestSetupApi(id, data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 200 || response.status === 201) {
          dispatch(
            updateEnrollmentRequestSetupSuccess(response.data.response)
          );
          history.push({
            pathname: '/enrollment-roster-configuration-page',
            state: navigationState,
          });
          const message =
            response.data?.message ??
            response.data?.response?.message ??
            `${data.profile_name} updated successfully`;
          appToast.showSuccess(message);
        }
        return { success: true };
      })
      .catch((error) => {
        dispatch(fetchEnd());
        return Promise.resolve({ success: false, error });
      });
  };
};

const updateEnrollmentRequestSetupApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.put(`/config/enrollment-type/${id}`, data, { headers });
};

export const updateEnrollmentRequestSetupSuccess = (data) => {
  return {
    type: UPDATE_ENROLLMENT_REQUEST_SETUP_SUCCESS,
    data,
  };
};

// Process Membership Update Request
export const processEnrollmentUpdateRequest = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await processEnrollmentUpdateRequestApi(data);
      dispatch(fetchEnd());
      dispatch(processEnrollmentUpdateRequestSuccess(response.data));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, data: response.data };
      }
      return { success: true, data: response.data };
    } catch (error) {
      dispatch(fetchEnd());
      dispatch(processEnrollmentUpdateRequestFail(error));
      const logNumber = error?.response?.data?.log_number;
      if (logNumber) {
        await handleExecutionLog(dispatch, logNumber);
        return { success: false, data: error?.response?.data };
      }
      throw error;
    }
  };
};

const processEnrollmentUpdateRequestApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('enrollment-request/process', data, { headers });
};

export const processEnrollmentUpdateRequestSuccess = (data) => {
  return {
    type: PROCESS_ENROLLMENT_UPDATE_REQUEST_SUCCESS,
    data,
  };
};

export const processEnrollmentUpdateRequestFail = (error) => {
  return {
    type: PROCESS_ENROLLMENT_UPDATE_REQUEST_FAIL,
    error,
  };
};

export const postEnrollmentUpdateRequest = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return postEnrollmentUpdateRequestApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(postEnrollmentUpdateRequestSuccess(response.data));
        appToast.showSuccess('GPO Execution posted successfully');
        return response.data;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(postEnrollmentUpdateRequestFail(error));
        // Error toast is already shown by axios interceptor, no need to show again
        throw error;
      });
  };
};

const postEnrollmentUpdateRequestApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('/membership-update-request/post', data, { headers });
};

export const postEnrollmentUpdateRequestSuccess = (data) => {
  return {
    type: POST_ENROLLMENT_UPDATE_REQUEST_SUCCESS,
    data,
  };
};

export const postEnrollmentUpdateRequestFail = (error) => {
  return {
    type: POST_ENROLLMENT_UPDATE_REQUEST_FAIL,
    error,
  };
};

export const getEnrollmentUpdateRequest = (filterFields) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getEnrollmentUpdateRequestApi(filterFields)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getEnrollmentUpdateRequestSuccess(response.data.response || response.data)
        );
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getEnrollmentUpdateRequestFail(error));
      });
  };
};

const getEnrollmentUpdateRequestApi = (filterFields) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.post('/members', filterFields, { headers });
};

export const getEnrollmentUpdateRequestSuccess = (data) => {
  return {
    type: GET_ENROLLMENT_UPDATE_REQUEST_SUCCESS,
    data,
  };
};

export const getEnrollmentUpdateRequestFail = (error) => {
  return {
    type: GET_ENROLLMENT_UPDATE_REQUEST_FAIL,
    error,
  };
};

export const getEnrollmentUpdateRequestById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return getEnrollmentUpdateRequestByIdApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getEnrollmentUpdateRequestByIdSuccess(response.data.response || response.data)
        );
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getEnrollmentUpdateRequestByIdFail(error));
      });
  };
};

const getEnrollmentUpdateRequestByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`/membership-update-request/${id}`, { headers });
};

export const getEnrollmentUpdateRequestByIdSuccess = (data) => {
  return {
    type: GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_SUCCESS,
    data,
  };
};

export const getEnrollmentUpdateRequestByIdFail = (error) => {
  return {
    type: GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_FAIL,
    error,
  };
};

// Get Membership Update Request List (GET request)
export const getEnrollmentUpdateRequestList = (page = 1, limit = 0) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getEnrollmentUpdateRequestListApi(page, limit)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getEnrollmentUpdateRequestListSuccess(response.data.response || response.data)
        );
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getEnrollmentUpdateRequestListFail(error));
      });
  };
};

const getEnrollmentUpdateRequestListApi = (page, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  const params = new URLSearchParams();
  if (page && page !== 1) params.append('page', page);
  if (limit) params.append('limit', limit);

  const queryString = params.toString();
  const url = `/membership-update-request?limit=100`;

  return axios.get(url, { headers });
};

// GPO Execution List (GET request)
export const getGpoExecutionList = (page = 1, limit = 0) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getGpoExecutionListApi(page, limit)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getGpoExecutionListSuccess(response.data.response || response.data));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getGpoExecutionListFail(error));
      });
  };
};

const getGpoExecutionListApi = (page, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  const params = new URLSearchParams();
  if (page) params.append('page', page);
  if (limit) params.append('limit', limit);

  const queryString = params.toString();
  const url = `/gpo-execution-list-page${queryString ? `?${queryString}` : ''}`;

  return axios.get(url, { headers });
};

export const getGpoExecutionListSuccess = (data) => {
  return {
    type: GET_GPO_EXECUTION_LIST_SUCCESS,
    data,
  };
};

export const getGpoExecutionListFail = (error) => {
  return {
    type: GET_GPO_EXECUTION_LIST_FAIL,
    error,
  };
};

// GPO Execution Details (GET request)
export const getGpoExecutionById = (id) => {
  return (dispatch) => {
    if (!id) return;
    dispatch(fetchStart());
    getGpoExecutionByIdApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getGpoExecutionByIdSuccess(response.data.response || response.data));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getGpoExecutionByIdFail(error));
      });
  };
};

const getGpoExecutionByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get(`/gpo-execution-list-page/${id}`, { headers });
};

export const getGpoExecutionByIdSuccess = (data) => {
  return {
    type: GET_GPO_EXECUTION_BY_ID_SUCCESS,
    data,
  };
};

export const getGpoExecutionByIdFail = (error) => {
  return {
    type: GET_GPO_EXECUTION_BY_ID_FAIL,
    error,
  };
};

export const getEnrollmentUpdateRequestListSuccess = (data) => {
  return {
    type: GET_ENROLLMENT_UPDATE_REQUEST_LIST_SUCCESS,
    data,
  };
};

export const getEnrollmentUpdateRequestListFail = (error) => {
  return {
    type: GET_ENROLLMENT_UPDATE_REQUEST_LIST_FAIL,
    error,
  };
};

// Delete Membership Update Request (GPO Execution row)
export const deleteEnrollmentUpdateRequest = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return deleteEnrollmentUpdateRequestApi(id)
      .then(() => {
        dispatch(fetchEnd());
        appToast.showSuccess('GPO Execution deleted successfully');
        return Promise.resolve();
      })
      .catch((error) => {
        dispatch(fetchEnd());
        return Promise.reject(error);
      });
  };
};

const deleteEnrollmentUpdateRequestApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.delete(`/membership-update-request/${id}`, { headers });
};

// new
export const getAttributeManagementListData = (data, page = 1, limit = 10, attributeType = null) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAttributeManagementListDataApi(data, page, limit, attributeType)
      .then((response) => {
        //console.log('Raw API Response:', response);
        if (response.data && response.data.response) {
          const { records, total_record } = response.data.response;
          //console.log(`Received ${records?.length || 0} records with attribute_type filter: ${attributeType}`);
          if (records && Array.isArray(records)) {
            // Transform the records to match the expected format
            const transformedRecords = records.map(record => ({
              ...record,
              id: record.ID, // Ensure lowercase 'id' exists for DataGrid
              values: record.values || [] // Include values array
            }));

            // Get the total count from the response
            const totalCount = total_record || records.length;

            dispatch(getAttributeManagementListDataSuccess(transformedRecords, totalCount));
          } else {
            console.warn('No records found in the API response');
            dispatch(getAttributeManagementListDataSuccess([], 0));
          }
        } else {
          console.warn('Invalid API response format:', response.data);
          dispatch(getAttributeManagementListDataSuccess([], 0));
        }
        dispatch(fetchEnd());
      })
      .catch((error) => {
        console.error('API Error:', error);
        dispatch(fetchEnd());
        dispatch(getAttributeManagementListDataSuccess([], 0));
      });
  };
};

const getAttributeManagementListDataApi = (data, page = 1, limit = 10, attributeType = null) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  let url = `/mdm/attribute-types?with_values=true`;
  // Add attribute_type filter if provided
  if (attributeType) {
    url += `&attribute_type=${attributeType}`;
  }
  // console.log('Fetching attributes with URL:', url);
  result = axios.get(url, { headers: headers });
  return result;
};

export const getAttributeManagementListDataSuccess = (data, totalCount) => {
  return {
    type: ATTRIBUTE_MANAGEMENT_LIST_DATA_SUCCESS,
    data,
    totalCount
  };
};

// export const deleteAttributeManagementData = (id) => {
//   return (dispatch) => {
//     dispatch(fetchStart());
//     deleteAttributeManagementDataApi(id)
//       .then((response) => {
//         dispatch(fetchEnd());
//         if (response.status === 200) {
//           appToast.showSuccess('Successfully deleted');
//         } else {
//           //appToast.showError(ServerError);
//         }
//       })
//       .catch((error) => {
//         dispatch(fetchEnd());
//         //appToast.showError(ServerError);
//       });
//   };
// };

export const deleteAttributeManagementData = (id, name) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return deleteAttributeManagementDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        //    if (response.status === 200) {
        //   appToast.showSuccess(`Attribute '${name}' deleted successfully`);
        // } else {
        //   //appToast.showError(ServerError);
        // }
        return response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //appToast.showError(ServerError);
        const rawError = error?.response?.data;
        const errorResponse = rawError?.response ? rawError.response : rawError;
        throw errorResponse || error;
      });
  };
};

const deleteAttributeManagementDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('/mdm/attribute-type/' + id, { headers: headers });
  return result;
};

export const deleteAttributeManagementDataSuccess = (data) => {
  return {
    type: DELETE_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS,
    data,
  };
};

export const saveEditAttributeManagementData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    saveEditAttributeManagementDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 200) {
          appToast.showSuccess('Successfully saved');
        } else {
          //appToast.showError(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //appToast.showError(ServerError);
      });
  };
};

const saveEditAttributeManagementDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('mdm-material-master', data, { headers: headers });
  return result;
};

export const saveEditAttributeManagementDataSuccess = (data) => {
  return {
    type: SAVE_EDIT_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS,
    data,
  };
};

export const uploadAttributeManagementFile = (file) => {
  return (dispatch) => {
    uploadAttributeManagementFileApi(file)
      .then((response) => {
        if (response.status === 200) {
          // window.location.reload();
          appToast.showSuccess('File has been successfully uploaded.');
        } else {
          //appToast.showError(ServerError);
        }
      })
      .catch((error) => {
        //appToast.showError(ServerError);
      });
  };
};

const uploadAttributeManagementFileApi = (file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('mdm-material-master-upload', file, { headers: headers });
  return result;
};

// Action creators for user-defined attributes
export const createUserDefinedAttributeSuccess = (data) => {
  return {
    type: CREATE_USER_DEFINED_ATTRIBUTE_SUCCESS,
    data,
  };
};

export const createUserDefinedAttributeFail = (error) => {
  return {
    type: CREATE_USER_DEFINED_ATTRIBUTE_FAIL,
    error,
  };
};

// Redux thunk action to create user-defined attribute with values
export const createUserDefinedAttribute = (attributeData, attributeValues = [], deletedIds = []) => {
  return (dispatch) => {
    dispatch(fetchStart());

    // Create payload with the new structure
    const payload = {
      attribute_type: {
        attribute_type: 'user defined',
        attribute: attributeData.attribute,
        attribute_description: attributeData.attribute_description,
        attribute_label: attributeData.attribute_label,
        data_type: attributeData.data_type,
        max_length: attributeData.max_length,
        numeric_scale: attributeData.numeric_scale,
        is_array: attributeData?.is_array || false,
        application_type: attributeData.application_type,
        display_type: attributeData.display_type,
        is_multiple_selection: attributeData.is_multiple_selection || false,
        query_name: attributeData.query_name || '',
        values_display_only: attributeData.values_display_only,
        foreign_table: attributeData.foreign_table || '',
        foreign_field: attributeData.foreign_field || '',
        description_table: attributeData.description_table || '',
        description_field: attributeData.description_field || '',
        reference_attribute: attributeData.reference_attribute || '',
        reference_attribute_application_type: attributeData.reference_attribute_application_type || '',
        standard_values_only: attributeData.standard_values_only || false,
        foreign_table_filter: attributeData.foreign_table_filter || {},
        search_only: attributeData.search_only || false
      },
      values: attributeValues,
      deleted_ids: deletedIds
    };

    return axios({
      method: 'post',
      url: '/mdm/attribute-type',
      data: payload,
      headers: {
        'Authorization': secureLocalStorage.getItem('aTk'),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(createUserDefinedAttributeSuccess(response.data));
        return response.data;
      })
      .catch(error => {
        console.error('Error creating attribute:', error);
        dispatch(fetchEnd());
        dispatch(createUserDefinedAttributeFail(error));
        //appToast.showError('Error creating attribute: ' + (error.response?.data?.message || error.message));
        throw error;
      });
  };
};

// Get attribute values for a specific attribute type
export const getAttributeValues = (attributeTypeId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAttributeValuesApi(attributeTypeId)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getAttributeValuesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        console.error('Error fetching attribute values:', error);
      });
  };
};

const getAttributeValuesApi = (attributeTypeId) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`/mdm/attribute-values?attribute_type_id=${attributeTypeId}&with_values=true`, { headers: headers });
};

export const getAttributeValuesSuccess = (data) => {
  return {
    type: GET_ATTRIBUTE_VALUES_SUCCESS,
    data,
  };
};

// Get a specific attribute type by ID
export const getAttributeTypeById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAttributeTypeByIdApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getAttributeTypeByIdSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        console.error('Error fetching attribute type:', error);
      });
  };
};

const getAttributeTypeByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`/mdm/attribute-type/${id}?with_values=true`, { headers: headers });
};

export const getAttributeTypeByIdSuccess = (data) => {
  return {
    type: GET_ATTRIBUTE_TYPE_BY_ID_SUCCESS,
    data,
  };
};

// Update User Defined Attribute
export const updateUserDefinedAttributeStart = () => ({
  type: 'UPDATE_USER_DEFINED_ATTRIBUTE_START',
});

export const updateUserDefinedAttributeSuccess = (data) => ({
  type: UPDATE_USER_DEFINED_ATTRIBUTE_SUCCESS,
  data,
});

export const updateUserDefinedAttributeFail = (error) => ({
  type: UPDATE_USER_DEFINED_ATTRIBUTE_FAIL,
  error,
});

export const updateUserDefinedAttribute = (attributeId, attributeTypeData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(updateUserDefinedAttributeStart());

    // Return a promise so we can handle success/failure in the component
    return new Promise((resolve, reject) => {
      // Update attribute type and values in a single call
      axios({
        method: 'put',
        url: `/mdm/attribute-type/${attributeId}`,
        data: attributeTypeData, // Already contains attribute_type and values
        headers: {
          'Authorization': secureLocalStorage.getItem('aTk'),
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          //console.log('Attribute updated successfully:', response.data);
          dispatch(fetchEnd());
          dispatch(updateUserDefinedAttributeSuccess(response.data));
          resolve(response.data);
        })
        .catch(error => {
          console.error('Error updating attribute:', error);
          dispatch(fetchEnd());
          dispatch(updateUserDefinedAttributeFail(error));
          //appToast.showError('Error updating attribute: ' + (error.response?.data?.message || error.message));
          reject(error);
        });
    });
  };
};

export const getDataTypes = () => {
  return (dispatch) => {
    dispatch(fetchStart());

    getDataTypesAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getDataTypesSuccess(response.data.response));
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};
const getDataTypesAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get('/mdm/data-types', { headers });
};
export const getDataTypesSuccess = (data) => {
  return {
    type: GET_DATA_TYPES,
    data,
  };
};
// Added updateAttributeValue action creators to handle updating an attribute value in the attribute value table
// using the API endpoint /mdm-attribute-value/{id}.
// Expected payload example:
// {
//   "attribute_type_id": 1,
//   "value": "Updated HR",
//   "description": "Updated Human Resources"
// }
export const updateAttributeValueSuccess = (data) => {
  return {
    type: UPDATE_ATTRIBUTE_VALUE_SUCCESS,
    data,
  };
};

export const updateAttributeValueFail = (error) => {
  return {
    type: UPDATE_ATTRIBUTE_VALUE_FAIL,
    error,
  };
};

export const updateAttributeValue = (attributeValueId, valueData) => {
  return async (dispatch) => {
    try {
      const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
        'Content-Type': 'application/json',
      };
      const result = await axios.put(`/mdm/attribute-value/${attributeValueId}`, valueData, { headers });
      dispatch(updateAttributeValueSuccess(result.data));
      return Promise.resolve(result.data);
    } catch (error) {
      dispatch(updateAttributeValueFail(error.response?.data || { message: error.message }));
      return Promise.reject(error);
    }
  };
};

// Add a recursive function to update multiple attribute values
export const updateMultipleAttributeValues = (changedValues, index = 0) => {
  return async (dispatch) => {
    // Base case: all items processed
    if (index >= changedValues.length) {
      return Promise.resolve();
    }

    const current = changedValues[index];
    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
      'Content-Type': 'application/json',
    };

    try {
      // Call the API to update this attribute value
      const result = await axios.put(
        `/mdm-attribute/value/${current.id}`,
        {
          attribute_type_id: current.attribute_type_id,
          value: current.value,
          description: current.description,
        },
        { headers }
      );

      dispatch({
        type: UPDATE_ATTRIBUTE_VALUE_SUCCESS,
        data: result.data,
      });

      // Recursively process the next item
      return dispatch(updateMultipleAttributeValues(changedValues, index + 1));
    } catch (error) {
      dispatch({
        type: UPDATE_ATTRIBUTE_VALUE_FAIL,
        error: error.response?.data || { message: error.message },
      });
      return Promise.reject(error);
    }
  };
};

export const clearAttributeTypeById = (id) => {
  return {
    type: CLEAR_ATTRIBUTE_TYPE_BY_ID,
    id,
  };
};

// get Attributes dropdown values
export const getAttributeDropdownValues = (data, type, page, isHandsonTableData, uniqueKey) => {
  return (dispatch) => {
    dispatch(getAttributeDropdownValuesSuccess({}, true));
    getAttributeDropdownValuesApi(data, type)
      .then((response) => {
        const responseData = response.data?.response || response.data?.data || /*response.data ||*/[];
        if (type == 'multiple')
          dispatch(getAttributeDropdownValuesSuccess(responseData, false, page, isHandsonTableData));
        else {
          const key = uniqueKey || data.attribute_name
          const payload = { [key]: responseData || [] };
          dispatch(getAttributeDropdownValuesSuccess(payload, false, page, isHandsonTableData));
        }
      })
      .catch((error) => {
        dispatch(getAttributeDropdownValuesSuccess({}, false, page, isHandsonTableData));
      });
  };
};

const getAttributeDropdownValuesApi = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (type == 'multiple')
    return axios.post('/mdm/attribute-values?multiAttribute=true', data, { headers: headers });
  else
    return axios.post('/mdm/attribute-values', data, { headers: headers });
};

export const getAttributeDropdownValuesSuccess = (data, loader, page, isHandsonTableData) => {
  return {
    type: isHandsonTableData ? GET_ATTRIBUTE_DROPDOWN_VALUES_HANDSONTABLE : GET_ATTRIBUTE_DROPDOWN_VALUES,
    data,
    loader,
    page
  };
};

// get Attribute Labels for Level dropdown
export const getAttributeLabels = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await getAttributeLabelsApi(data);
      dispatch(getAttributeLabelsSuccess(response.data));
      return response;
    } catch (error) {
      dispatch(getAttributeLabelsFailed(error));
      throw error;
    } finally {
      dispatch(fetchEnd());
    }
  };
};

const getAttributeLabelsApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (data)
    return axios.post('/mdm/attribute-labels', data, { headers: headers });
  else
    return axios.post('/mdm/attribute-labels', { headers: headers });
};

export const getAttributeLabelsSuccess = (data) => {
  return {
    type: GET_ATTRIBUTE_LABELS_SUCCESS,
    data,
  };
};

export const getAttributeLabelsFailed = (error) => {
  return {
    type: 'GET_ATTRIBUTE_LABELS_FAILED',
    error,
  };
};